/*
 * @Author: cmchiu
 * @Date: 2022-05-27 09:47:13
 * @LastEditTime: 2023-05-23 14:18:51
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\utils\common.js
 *
 */
import $ from 'jquery'

//跳转到锚点
function goAnchor(selector) {
    var anchor = this.$el.querySelector(selector) //获取元素

    if (anchor) {
        setTimeout(() => {
            //页面没有渲染完成时是无法滚动的，因此设置延迟
            anchor.scrollIntoView({ behavior: 'smooth' }) //js的内置方法，可滚动视图位置至元素位置
            let targetOffset = anchor.getBoundingClientRect()
            window.scrollTo({
                left: 0,
                top:
                    (!window.scrollY ? targetOffset.y : window.scrollY) - (document.body.clientWidth >= 993 ? 134 : 87),
                behavior: 'smooth',
            })
        }, 1000)
    }
}

//获取参数
function GetQueryString(name) {
    //var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var href = window.location.href
    var r = getSearchString(name, href)

    if (r != null) return decodeURI(r)
    return null
}

function getSearchString(key, Url) {
    var str = Url
    str = str.substring(1, str.length)

    if (str.indexOf('?') != -1) {
        var arr = str.split('?')[1].split('&') // 获取？后的参数内容，并以&分隔字符串，获得类似name=xiaoli这样的元素数组
        var obj = new Object()
        // 将每一个数组元素以=分隔并赋给obj对象
        for (var i = 0; i < arr.length; i++) {
            var tmp_arr = arr[i].split('=')
            obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
        }
        return obj[key]
    }
}

/**
 * 判斷日期是否在區間內，在區間內返回true，否返回false
 * @param dateString 日期字符串
 * @param startDateString 區間開始日期字符串
 * @param endDateString 區間結束日期字符串
 * @returns {Number}
 */
function isDateBetween(dateString, startDateString, endDateString) {
    var curDate = new Date(dateString),
        beginDate = new Date(startDateString),
        endDate = new Date(endDateString)
    if (curDate >= beginDate && curDate <= endDate) {
        return true
    }
    return false
}

export { goAnchor, GetQueryString, isDateBetween }
